import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

export default function Vision2030() {
  const { t, dir } = useI18n();
  const isRtl = dir === "rtl";
  const v = t.vision2030;

  return (
    <section
      id="vision2030"
      className="relative bg-background overflow-hidden"
      data-testid="vision2030-section"
    >
      {/* Decorative giant 2030 watermark */}
      <div
        aria-hidden
        className={`pointer-events-none absolute -bottom-16 ${isRtl ? "-left-10" : "-right-10"} text-[260px] md:text-[420px] font-black leading-none text-primary/[0.05] tracking-tighter select-none`}
      >
        2030
      </div>

      <div className="container-page section-y relative">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-5"
          >
            <span className="overline">{v.eyebrow}</span>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-black leading-[1.05]">
              {v.heading1} <br />
              <span className="text-primary">{v.heading1Accent}</span>
            </h2>
            <p className="mt-6 text-muted-foreground leading-relaxed max-w-md">
              {v.description}
            </p>

            <a
              href="#contact"
              className="mt-10 inline-flex items-center gap-3 px-6 py-3 bg-primary text-primary-foreground text-sm font-semibold uppercase tracking-[0.18em] hover:bg-primary/90 transition-colors group"
              data-testid="vision2030-cta"
            >
              {v.cta}
              <ArrowRight className={`h-4 w-4 transition-transform ${isRtl ? "scale-x-[-1] group-hover:-translate-x-1" : "group-hover:translate-x-1"}`} />
            </a>
          </motion.div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-px bg-border border border-border">
            {v.pillars.map((p, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: 0.1 + i * 0.08 }}
                className="group relative bg-background p-6 md:p-8 hover:bg-secondary hover:text-secondary-foreground transition-colors duration-500 overflow-hidden"
                data-testid={`vision2030-pillar-${i}`}
              >
                <div className="text-[10px] uppercase tracking-[0.24em] text-primary font-bold">
                  {p.tag}
                </div>
                <h3 className="mt-4 text-xl md:text-2xl font-bold leading-tight">
                  {p.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground group-hover:text-secondary-foreground/70 transition-colors">
                  {p.text}
                </p>
                <div className="mt-6 h-px w-10 bg-primary/60 group-hover:w-20 transition-all duration-500" />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
